import {colorSchemes} from '@nivo/colors';
import {QuestionReportAnswer} from '../incase-domain/analytics';
import {likertScaleReportsColors} from '../incase-domain/components/report/answer/likertScale/ReportAnswerLikertScale';

const QUESTION_REPORT_COLORS = colorSchemes.set3;
const basicColors = ['#0B945A', '#5611A5', '#D83BCF', '#A079CC', '#FACC15'];

export interface SizeType {
    height: number;
    barWidth: number;
    fontSize: string;
}

export interface DataSet {
    id: number;
    value: number;
    label: string;
    tooltip: string;
    color: string;
    noOfAnswers: number;
}

export const mapSize = (size: string | undefined, scale: number): SizeType => {
    switch (size) {
        case 'sm':
            return {
                height: 300 * scale,
                barWidth: 50 * scale,
                fontSize: `${10 * scale}px`,
            };
        case 'md':
            return {
                height: 400 * scale,
                barWidth: 60 * scale,
                fontSize: `${12 * scale}px`,
            };
        default:
            return {
                height: 500 * scale,
                barWidth: 70 * scale,
                fontSize: `${14 * scale}px`,
            };
    }
};

export const getColorBasic = (index: number): string => {
    return basicColors[index % basicColors.length];
};

export const getColor = (index: number): string => {
    return QUESTION_REPORT_COLORS[index % QUESTION_REPORT_COLORS.length];
};

export const getColorForLikertScale = (count: number): string[] => {
    const middleIndex = Math.floor(likertScaleReportsColors.length / 2);

    const result: string[] = [likertScaleReportsColors[middleIndex]];

    let step = 1;
    while (result.length < count) {
        if (middleIndex - step >= 0 && result.length < count) {
            result.unshift(likertScaleReportsColors[middleIndex - step]);
        }

        if (middleIndex + step < likertScaleReportsColors.length && result.length < count) {
            result.push(likertScaleReportsColors[middleIndex + step]);
        }

        step += 1;
    }

    return result;
};

export const mapAnswersToDataSet = (answers: QuestionReportAnswer[], noAnswersYet?: boolean): DataSet[] => {
    return answers.map((a, i) => ({
        id: i + 1,
        noOfAnswers: a.noOfAnswers,
        value: a.percentage,
        label: `${i + 1} - ${a.answerText}`,
        tooltip: noAnswersYet ? 'Dummy data' : `${a.answerText}: ${a.noOfAnswers}`,
        color: getColor(i),
    }));
};
